module.exports = __webpack_public_path__ + "static/media/navbar-brand-icon.28d6911f.png";